import React from "react";
import "./styles.css";

const TextAreaComponent = ({ placeholder, value, setValue }) => {
  const handleChange = (e) => {
    setValue(e.target.value);
  };
  return (
    <textarea
      className="text-area-component-container"
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
    />
  );
};

export default TextAreaComponent;
